<template>
    <div>
        <Breadcrumb class="breadcrumb">
            <BreadcrumbItem  class="click" to="/teachAdmin/appraisal/index">
                实训考核管理
            </BreadcrumbItem>
            <BreadcrumbItem >查看实训考核</BreadcrumbItem>
        </Breadcrumb>
        <div class="create-box">
            <div class="create-box-title">
                <h3>基本信息</h3>
            </div>
            <Form label-position="left" :label-width="110">
                <Row>
                    <Col span="10">
                        <FormItem label="实训名称" class="form-item" prop="name">
                            {{detail.name}}
                        </FormItem>
                        <br />
                        <FormItem label="实训课程" class="form-item" prop="course_id">
                            {{detail.course_name}}
                        </FormItem>
                        <br />
                        <FormItem label="班级" prop="classes_ids">
                            <Tag v-for="item in detail.classes_info">{{item.name}}</Tag>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        </div>
    </div>
</template>
<script>
    import {mapActions} from 'vuex'
    export default {
        name:'create',
        data(){
            return {
                id:0,
                detail:{},
            }
        },
        methods:{
            ...mapActions({
                getAppraisalInfo:'appraisal/getAppraisalInfo',

            }),
        },
        computed:{
        },
        mounted() {
            let _this = this;
            _this.id = this.$route.query.id;
            if(_this.id > 0 ){
                // 获取编辑信息
                this.getAppraisalInfo({
                    id:_this.id,
                    callback:res=>{
                       _this.detail = res;
                    },
                    error:msg=>{
                        _this.$Message.error(msg);
                    }
                })
            }
        }
    }
</script>
<style scoped lang="less">
    @import "../../style/index";
    @import "../../../../assets/style/exercises";
</style>
